module.exports = __webpack_public_path__ + "img/live_sa.fb0d27a9.png";